import { render, staticRenderFns } from "./UsageVoiceTopTenPieChart.vue?vue&type=template&id=d1daf6fa&scoped=true&"
import script from "./UsageVoiceTopTenPieChart.vue?vue&type=script&lang=js&"
export * from "./UsageVoiceTopTenPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1daf6fa",
  null
  
)

export default component.exports